import { dateFormatter } from 'common/helpers/date.helper';
import { IPurchaseOrderModel } from 'entities/PurchaseOrder/PurchaseOrder.models';

export const exportPurchaseOrderToExcel = async (order: IPurchaseOrderModel, franchiseeName: string) => {
  const ExcelJS = await import('exceljs');
  const { saveAs } = await import('file-saver');

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('Order');

  sheet.columns = [
    { width: 30 },
    { width: 12 },
    { width: 12 },
    { width: 10 },
    { width: 14 },
    { width: 20 },
  ];

  const titleRow = sheet.addRow(['Order Information']);
  titleRow.font = { bold: true, size: 14 };

  sheet.addRow([]);
  sheet.addRow(['SO#', order.sonum]);
  sheet.addRow(['Status', order.status]);
  sheet.addRow(['Franchisee', franchiseeName]);
  sheet.addRow(['Ordered', order.orderedAt ? dateFormatter(order.orderedAt, 'MM/DD/YYYY HH:mm') : '-']);
  sheet.addRow(['Delivered', order.deliveredAt ? dateFormatter(order.deliveredAt, 'MM/DD/YYYY HH:mm') : '-']);
  sheet.addRow(['Received By', order.receivedBy || '-']);
  sheet.addRow(['Total Amount', order.amount]);
  sheet.addRow([]);

  const headerRow = sheet.addRow(['Item', 'SO Qty', 'SI Qty', 'Var', 'Unit Cost', 'Adjusted Total Cost']);
  headerRow.font = { bold: true };
  headerRow.eachCell((cell) => {
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE8EAED' } };
  });

  order.items.forEach((item) => {
    sheet.addRow([
      item.name,
      item.orderCount,
      item.siQty,
      item.variance,
      item.price,
      item.adjustedTotalCost,
    ]);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, `SO${order.sonum}.xlsx`);
};
